var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentCardSuccess = function SvgPaymentCardSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 156,
    viewBox: "0 0 151 98"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    fillRule: "nonzero",
    d: "M101.31 1.667 16.68 21.207a5.44 5.44 0 0 0-4.077 6.523l11.59 50.2a5.44 5.44 0 0 0 6.524 4.077l84.631-19.54a5.44 5.44 0 0 0 4.077-6.523l-11.59-50.2a5.44 5.44 0 0 0-6.524-4.077M16.985 22.531l84.631-19.539a4.08 4.08 0 0 1 4.894 3.058l11.59 50.2a4.08 4.08 0 0 1-3.059 4.893L30.41 80.682a4.08 4.08 0 0 1-4.894-3.058l-11.59-50.2a4.08 4.08 0 0 1 3.059-4.893"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#541CC4",
    d: "m15.971 29.725 90.225-20.83 2.55 11.048-90.224 20.83z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96.378,
    height: 61.039,
    x: 27.087,
    y: 20.902,
    fill: "#FFF",
    stroke: "#444",
    strokeWidth: 1.36,
    rx: 4.76
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1D8B7",
    fillRule: "nonzero",
    d: "M118.994 21.972c1.877 0 3.4 1.523 3.4 3.4V77.47a3.4 3.4 0 0 1-3.4 3.4H31.557a3.4 3.4 0 0 1-3.4-3.4V25.372c0-1.877 1.523-3.4 3.4-3.4zm0 2.16H31.557a1.24 1.24 0 0 0-1.233 1.114l-.007.126V77.47c0 .642.488 1.17 1.114 1.234l.126.006h87.437a1.24 1.24 0 0 0 1.233-1.113l.007-.127V25.372a1.24 1.24 0 0 0-1.114-1.233z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.811,
    height: 12.315,
    x: 36.724,
    y: 37.626,
    fill: "#E1D8B7",
    stroke: "#988642",
    strokeWidth: 1.768,
    rx: 4.42
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#988642",
    fillRule: "nonzero",
    d: "M47.148 37.477V43.8h9.637v.5h-9.638v5.789h-.5V44.3l-10.173.001v-.5h10.173v-6.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#541CC4",
    d: "M43.15 41.909h7.496v3.748H43.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    fillRule: "nonzero",
    d: "M92.31 69.481a.68.68 0 0 1 .1 1.353l-.1.007H36.824a.68.68 0 0 1-.1-1.352l.1-.008zM53.223 61.45a.68.68 0 0 1 .1 1.353l-.1.007H36.824a.68.68 0 0 1-.1-1.353l.1-.007zm19.275 0a.68.68 0 0 1 .1 1.353l-.1.007H56.1a.68.68 0 0 1-.1-1.353l.1-.007zm19.276 0a.68.68 0 0 1 .1 1.353l-.1.007H75.376a.68.68 0 0 1-.1-1.353l.1-.007zm19.811 0a.68.68 0 0 1 .1 1.353l-.1.007H95.187a.68.68 0 0 1-.1-1.353l.1-.007z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.039,
    height: 5.039,
    x: 26.457,
    y: 92.083,
    fill: "#988642",
    fillRule: "nonzero",
    rx: 2.52
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#988642",
    fillRule: "nonzero",
    d: "m14.088 87.803.8 1-5.039 4.031-.8-.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    fillRule: "nonzero",
    d: "m12.08 71.925-1.51.076.05 1.006 1.51-.075zm-3.524.176-1.51.075.05 1.007 1.51-.075zm-3.523.176-1.51.075.05 1.007 1.51-.076zm-3.523.176L0 72.528l.05 1.007 1.51-.076z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.299,
    height: 6.299,
    x: 129.134,
    y: 0.114,
    fill: "#541CC4",
    fillRule: "nonzero",
    rx: 3.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    fillRule: "nonzero",
    d: "M142.832 26.74h1.89v-1.26h-1.89zm4.409 0h1.89v-1.26h-1.89zm-12.438 20.3 1.413 1.255.837-.941-1.413-1.256zm3.296 2.929 1.413 1.255.837-.942-1.413-1.255zm3.297 2.929 1.412 1.255.837-.942-1.413-1.255zm3.296 2.929 1.413 1.255.836-.942-1.412-1.255zm3.296 2.928 1.413 1.256.837-.942-1.413-1.255z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1D872E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.49 9.68a1.31 1.31 0 0 1 1.858-.258c.534.415.678 1.17.336 1.771l-.084.127-13.806 18.525-7.245-6.912a1.376 1.376 0 0 1-.064-1.914 1.31 1.31 0 0 1 1.76-.163l.114.098 5.1 4.866z"
  })))));
};
export default SvgPaymentCardSuccess;